import { render } from "./EventviewBetAssist.vue?vue&type=template&id=d0c2387c"
import script from "./EventviewBetAssist.vue?vue&type=script&lang=js"
export * from "./EventviewBetAssist.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__